import ds_AlertBar_GlobalSet from './ds_AlertBar_GlobalSet'
import ds_GlobalCode_GlobalSet from './ds_GlobalCode_GlobalSet'
import ds_GoogleTranslate_GlobalSet from './ds_GoogleTranslate_GlobalSet'
import ds_Logos_GlobalSet from './ds_Logos_GlobalSet'
import ds_Navigation_GlobalSet from './ds_Navigation_GlobalSet'
import ds_Socials_GlobalSet from './ds_Socials_GlobalSet'


export default {
    ds_AlertBar_GlobalSet,
    ds_GlobalCode_GlobalSet,
    ds_GoogleTranslate_GlobalSet,
    ds_Logos_GlobalSet,
    ds_Navigation_GlobalSet,
    ds_Socials_GlobalSet,
}